import { render, staticRenderFns } from "./CreateFixedRentalInformation.vue?vue&type=template&id=32232474&"
import script from "@/scripts/components/fixedRental/createFixedRentalInformation.js?vue&type=script&lang=js&"
export * from "@/scripts/components/fixedRental/createFixedRentalInformation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports